import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const dividerVariants = tv({
  slots: {
    root: "flex items-center",
    line: "flex-1 border-b border-line",
    label: "px-3 text-sm text-content-subtle",
  },
});

const { label, line, root } = dividerVariants();

const Line = ({ className, ...props }: ComponentProps<"div">) => {
  return <div className={line({ className })} {...props} />;
};

const Label = ({ className, ...props }: ComponentProps<"span">) => {
  return <span className={label({ className })} {...props} />;
};

const Root = ({ className, ...props }: ComponentProps<"div">) => {
  return <div className={root({ className })} {...props} />;
};

export const Divider = { Root, Label, Line };
